var AT_Main = {

	getWidthBrowser : function() { // Get width browser
		var myWidth;

		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE 
			myWidth = window.innerWidth;
		} 
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
			//IE 6+ in 'standards compliant mode' 
			myWidth = document.documentElement.clientWidth; 
		} 
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
			//IE 4 compatible 
			myWidth = document.body.clientWidth;  
		}

		return myWidth; 
	}
	
	,checkLayout : function() { // Function to check level of layout
		if(jQuery("#checkLayout .d-sm-block").css("display") == "block")
			return 1; //mobile layout
		else if(jQuery("#checkLayout .d-md-block").css("display") == "block")
			return 2; //tablet potrait layout
		else if(jQuery("#checkLayout .d-lg-block").css("display") == "block")
			return 3; //tablet landscape/medium desktop layout
		else if(jQuery("#checkLayout .d-xl-block").css("display") == "block")
			return 4; //desktop layout
	}

	,width_Nopadding : function(){ //in IE and Edge can't apply CSS calc()
		if (document.documentMode || /Edge/.test(navigator.userAgent)) {
			$('.no-padding').each(function(){
				var ele= $(this),
					winW = $(document).width(),
					parentW=$(this).parents().width(),
					margin = (winW - parentW) / 2 *(-1);
					if(winW > 992){
						ele.css({
							'margin-left': margin,
							'margin-right': margin
                           
						  });
					}
					if(winW <= 992){
						ele.css({
							'margin-left': 'auto',
							'margin-right': 'auto'
						  });
					}
							 
					
			})
		}
		
	}
  
	,homeSlideshow : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
              
                var _delay_time = '';
//                 if( parseInt(_bc_config.home_slideshow_auto_delay) > 0 ){
//                 	_delay_time = parseInt(_bc_config.home_slideshow_auto_delay);
//                 }
              
                if(jQuery('.home-slideshow-wrapper').data('autoplay')){
                	_delay_time = jQuery(value).data('time');
                }
              	
              	let autoPlay = jQuery('.home-slideshow-wrapper').attr('data-autoplay');
                var swiper = new Swiper('.swiper-container', {
                  	autoplay: _delay_time 
                  //,speed: _delay_time 
                    ,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: jQuery(value).data('animation')
                  	,setWrapperSize: false
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });	
                          
                        });
                    }
                });
            });
        }
    }
  
  	,homeIE : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
              
                var _delay_time = '';
                if( parseInt(_bc_config.home_slideshow_auto_delay) > 0 ){
                  _delay_time = parseInt(_bc_config.home_slideshow_auto_delay);
                }
              
                var swiper = new Swiper('.swiper-container', {
                    autoplay: _delay_time
                  	,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: 'fade'
                  	,setWrapperSize: true
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });	
                          
                        });
                    }
                });
            });
        }
    }
	
	
	,stickMenu : function() {
		let enable_stick = jQuery(".header-content").data('stick');
		let headerStyle = jQuery(".header-container").data('style');
		let verticalNavbar = jQuery(".vertical-navbar")

		let verticalNavbarOpened;
		if(verticalNavbar.hasClass('opened')){
			verticalNavbarOpened = true;
		}

		if(enable_stick){
		  //Keep track of last scroll
			let lastScroll = 0;
			let header = jQuery(".header-container");
			let body_content = jQuery("#body-content");
			let bt=$(header).height();
			jQuery(window).scroll(function() {
				//Sets the current scroll position
				let st = jQuery(this).scrollTop();

				//Determines up-or-down scrolling
				if (st > lastScroll) {
					
					//Replace this with your function call for downward-scrolling
					if (st > bt ) {
						header.addClass("header-fixed fadeInDown animated");
						body_content.addClass("has-header-fixed");
						
						if(headerStyle == '1' && verticalNavbar.hasClass('opened') ) {
							verticalNavbar.removeClass('opened');
							$('.vertical-navbar .dropdown').removeClass('menu-open');
							verticalNavbarOpened = false;
						}
						
					}
					
				}
				else {
					//Replace this with your function call for upward-scrolling
					if (st < bt) {
						header.removeClass("header-fixed fadeInDown animated");
						body_content.removeClass("has-header-fixed");
					}
				}
				//Updates scroll position
				lastScroll = st;
			});
		}

	}
  	,stickAddToCart : function() {
		if(!$('#col-main').hasClass('layout-pre-order')){
			$(window).on( 'scroll' , function() {
			var ps = jQuery(this).scrollTop();
			var _show_sticky = ($('#add-to-cart').offset().top);

			if ( _show_sticky < ps ) {
				$('.add-to-cart-sticky').addClass('show');  
			}
			else {
				$('.add-to-cart-sticky').removeClass('show');
			}
			});
		}
	}

	,toTopButton : function(){
		var to_top_btn = $("#scroll-to-top");
		if( 1 > to_top_btn.length ){
			return;
		}
		$(window).on( 'scroll' , function() {
			var b = jQuery(this).scrollTop();
			var c = jQuery(this).height();
			if (b > 100) { 
				var d = b + c / 2;
			}
			else { 
				var d = 1 ;
			}

			if (d < 1000 && d < c) { 
				jQuery("#scroll-to-top").removeClass('on off').addClass('off'); 
			} else {
				jQuery("#scroll-to-top").removeClass('on off').addClass('on'); 
			}
		});

		to_top_btn.on( 'click',function (e) {
			e.preventDefault();
			jQuery('body,html').animate({scrollTop:0},800,'swing');
		});
	}
	,smoothBody:function(bodyTop){
	
		if ($("#body-content").hasClass("has-header-fixed")) {	
			$(".has-header-fixed").css(
				{	
					"padding-top": bodyTop + "px"
				}
			)
		}		
		else{
			$("#body-content").removeAttr('style');
		}
					
	}

      
    ,toggleVerticalMenu : function(){
        jQuery(document).on('click', '.vertical-menu .head', function(e) {
          jQuery(this).toggleClass('opened');
					jQuery('.vertical-navbar').toggleClass('opened');
					$('.vertical-navbar .main-nav').find('.dropdown').first().toggleClass('menu-open');
        });
	}
  
  	,toggleCartSidebar : function(){
		jQuery('.cart-toggle').on('click',function (e) { 
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.cart-sb').toggleClass('opened');
			jQuery('body').toggleClass('cart-opened');
		});

		jQuery('#page-body, .c-close').on('click',function () {
			jQuery('.cart-sb').removeClass('opened');
			jQuery('html,body').removeClass('cart-opened');
          
            
          
			AT_Main.fixReturnScroll();
		}); 
	}
      	,toggleFilterMobileSb : function(){
		jQuery('.filter-mobile').on('click',function (e) { 
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.filters-mobile-sb').toggleClass('opened');
			jQuery('body').toggleClass('mobile-filter-opened');
		});

		jQuery('#page-body, .mobile-filter-close').on('click',function () {
			jQuery('.filters-mobile-sb').removeClass('opened');
			jQuery('html,body').removeClass('mobile-filter-opened');
          
            
          
			AT_Main.fixReturnScroll();
		}); 
	}
       	,toggleCarSelectorMobile : function(){
		jQuery('.carselector__mobile-cta').on('click',function (e) { 
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.carselector__mobile').toggleClass('opened');
			jQuery('body').toggleClass('carselector__mobile-opened');
		});
		jQuery('#page-body, .carselector__mobile-close').on('click',function () {
			jQuery('.carselector__mobile').removeClass('opened');
			jQuery('html,body').removeClass('carselector__mobile-opened');
			AT_Main.fixReturnScroll();
		}); 
	}
     	,toggleSortMobileSb : function(){
		jQuery('.sortby-mobile').on('click',function (e) { 
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.sortby-mobile-sb').toggleClass('opened');
			jQuery('body').toggleClass('mobile-sortby-opened');
		});

		jQuery('#page-body, .mobile-sortby-close').on('click',function () {
			jQuery('.sortby-mobile-sb').removeClass('opened');
			jQuery('html,body').removeClass('mobile-sortby-opened');
          
            
          
			AT_Main.fixReturnScroll();
		}); 
	}
  	,toggleFilterSidebar : function(){
        jQuery('.mobile-header-dropdown').on('click',function (e) {
            jQuery('.filter-sidebar').slideToggle("slow");
            jQuery('.mobile-header-dropdown .mobile-header-dropdown__downarrow-icon').toggleClass("active");
		})
    }
       	,toggleReg : function(){
        jQuery('.reg-icon.reg-toggle').on('click',function (e) {
            jQuery('.reg-sidebar').slideToggle("slow");
				})
	}
    ,parallaxIt : function() {
		if($(".parallax-section").length == 0) 
			return;
		$.fn.parallaxScroll = function(xpos, speedFactor, outerHeight) {
			var elem = $(this);
			var getHeight;
			var firstTop;
			var paddingTop = 0;

			//get the starting position of each element to have parallax applied to it      
			$(this).each(function(){
				firstTop = $(this).offset().top;
			});

			getHeight = function(jqo) {
				return jqo.outerHeight(true);
			};

			var j$element, top, height, pos;

			function update(){

				pos = $(window).scrollTop();             
				firstTop = elem.offset().top;
				height = getHeight(elem);
				
				if (pos + $(window).height() < firstTop || pos > firstTop + height) {
				  return;
				}

				if(AT_Main.checkLayout()!=1)
				  elem.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px",0);   
				else         
				  elem.css('backgroundPosition', xpos + " " + -Math.round((firstTop - pos) * speedFactor) + "px",0);  
			}       

			window.addEventListener('scroll', function(){ 
				update(); 
			}, false)

			update();
		}; 

		$(".parallax-section").parallaxScroll("50%",0.1);
	}
  
    ,handleOrderFormQty : function(){
      jQuery("body").on("click",".global-product-info-qty-plus",function(){
        q = $(this).prev();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 0 : value;
        value++;
        q.val(value);
      });

      jQuery("body").on("click",".global-product-info-qty-minus",function(){
        q = $(this).next();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 1 : value;
        if(value > 1){
          value--;
          q.val(value);
        }
      });
    }
  
  	,effectNavigation : function(){ // Make hover effect of navigation
      
      	jQuery(".top-account-holder").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
      
      	jQuery(".currency-block").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
      
      	jQuery(document).on('click','.searchbox>a',function(e){
            $(this).parents().find('.searchbox').toggleClass('open');
  		});
      
        jQuery('#city-phone-numbers').on("change", function(e) {
          var _newcity = jQuery(e.currentTarget).find(':selected').attr('value');
          $('#city-phone-number-label').html(_newcity);
        });
      
	}

	,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
		var windowW = jQuery(window).width();
		if(!($('#page-body').hasClass('boxed'))){
			jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
		}
			
		
		
		
	}

	,fixReturnScroll : function() {
		jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', ''); 
	}

  	,fixButton : function(){
      	jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
              	$(this).find('.product-button').addClass('fix');
            }
  		});
    }
  
  	,handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
		}
	,toggleDropdownVerticalMenu : function(){
		$('.vertical-navbar .main-nav>li').click(function(event){
			let e = this;
			if( event.target !== e ) {
			    return;
			}
			$('.vertical-navbar .main-nav>li').each(function(index,item){
	          	if(e != item) {
	            	$(item).removeClass('menu-open');
	          	}
        	})
			e = $(this);
			if(e.hasClass('dropdown')) {
				if(e.hasClass('menu-open')) {
					e.removeClass('menu-open');
				}
				else {
					e.addClass('menu-open'); 
				}
			}
		})
		$('body').click(function(element) {
			if ($(element.target).closest('.vertical-navbar').length == 0) {
				$('.vertical-navbar .main-nav>li.dropdown').removeClass('menu-open');
			}
		});

	}
    
	,menuOnMobile : function(){

        jQuery(document).on('click',function(e){
          //console.log(e.target);
        });
						
				jQuery(window).on('resize',function () {
					jQuery(".menu-mobile, .responsive-menu").removeClass("opened");
					jQuery("html,body").removeClass("menu-opened");
					AT_Main.fixReturnScroll();
				}); 
				let oldTitle=$('#title-menu').html();
      	jQuery('.mm-block-icons .wishlist-target, .mm-block-icons .compare-target, .m-close, .close-nd').on('click',function () {
					jQuery(".menu-mobile").removeClass("opened");
					jQuery("html,body").removeClass("menu-opened");
					jQuery(".dropdown").removeClass("menu-mobile-open");
				
					$('#title-menu').html(oldTitle)
				
					AT_Main.fixReturnScroll();
				});

				jQuery(document).on('click','.responsive-menu',function(e){
					e.stopPropagation();
					AT_Main.fixNoScroll();
					jQuery(".menu-mobile, .responsive-menu").toggleClass("opened");
					jQuery("html,body").toggleClass("menu-opened")
				});

			jQuery(".navbar .menu-list li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});

				if($('.mobile-version .menu-product-carousel').length > 0){
					setTimeout(function(){ 
						$('.mobile-version .menu-product-carousel').prepend('<li class="back-prev-menu"><i class="demo-icon ico-button-arrow"></i></li>');
					},500)	
				}
				
				jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .dropdown',function(event){
					
					if(event.target.tagName.toLowerCase() == 'a' ){
						return;
					}
					$('.menu-mobile').animate({
						scrollTop: 0
					}, 500);

					let title = $(this).find('a').first().text().trim().split('\n')[0];     
					let e = $(this);
	
					if (e.hasClass('dropdown') ) {
						let child = e.children('.dropdown-menu');
						if(child.length > 0){
							if (e.hasClass('menu-mobile-open') == false) {
								if(child.find('.banners').length > 0){
									child.find('.banners').each(function(){
										let el = $(this);
										let img = el.children('.dropdown-menu').find('img');
										if (img.hasClass('lazyloaded')) {
											let temp = el.children('.dropdown-menu').find('img').parents('li').first().html();
											el.parents('.dropdown-menu').first().append(el.html(temp).removeClass('dropdown'));
										}
									})
								}
								
								e.addClass('menu-mobile-open');
	
								if (title.length > 0) {
									$('#title-menu').fadeOut('400', function() {
											$('#title-menu').html(title).fadeIn('400');
									});
									
								}
								return false;
							}
						}
					}

				  if (($(event.target).hasClass('back-prev-menu')) || ($(event.target).hasClass('ico-button-arrow'))  ) {
						$(event.target).parents('.dropdown').first().removeClass('menu-mobile-open')
						let title = $(this).closest('.menu-mobile-open').find('a').first().text().trim().split('\n')[0];   
						if (title.length > 0) {
							$('#title-menu').fadeOut('400', function() {
									$('#title-menu').html(title).fadeIn('400'); 
							});
						}
						if(!$('.menu-mobile-open').length){
							$('#title-menu').fadeOut('400', function() {
								$('#title-menu').html(oldTitle).fadeIn('400');
						});
						}
					}

				});

				

      	jQuery(document).on('click','.sb-menu .dropdown-link, .expand',function(){
				var e=jQuery(this).parents(".dropdown").first();
            if (e.hasClass("s-open")) {
                e.removeClass("s-open");
            } else {
                e.addClass("s-open");
            }
				})
        jQuery(document).on('click','.collection-filter__sidebar h4',function(){
				var e=jQuery(this).parents(".collection-filter__header").first();
            if (e.hasClass("filter-open")) {
                e.removeClass("filter-open");
            } else {
                e.addClass("filter-open");
            }
				})
      
      	jQuery(document).on('click','.currency_wrapper',function(){	
            if ($('.currency-block').hasClass("opened")) {
                $('.currency-block').removeClass("opened");
            } else {
                $('.currency-block').addClass("opened");
            }
				});
      
      	jQuery(document).on('click','.bc-toggle',function(){
				var e=jQuery(this);
            if (e.hasClass("opened")) {
                e.removeClass("opened");
            } else {
                e.addClass("opened");
            }
				});
      
      	jQuery(document).on('click','.top-cart-holder.hover-dropdown .cart-target',function(){
					var e=jQuery(this);
					if (e.hasClass("opened")) {
							e.removeClass("opened");
					} else {
							e.addClass("opened");
					}
				});

	}
	
	,handleMenuMultiLine : function() {
		var outItem = "";
		var down = false;

		var top = 0;

		jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
			var target = jQuery(e.currentTarget);

			if( down && outItem != "") {
				outItem.addClass("hold");
				setTimeout(function(){
					if(outItem != "")
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				},500);

				if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
				{       
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				}
			}
			else {
				outItem = "";
			}

		});

		jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

			var target = jQuery(e.currentTarget);

			if( e.pageY >= target.offset().top + 50 ) { //move down
				down = true;
			}

			if( target.hasClass("dropdown") ) { //target has child

				if(outItem == "")
					outItem = target;
			}

		});
	}
  
  	,lookbooks_initor : function(){ 
		if( jQuery('.bc-lookbooks.lookbooks.margin-row').length > 0 ){
		  
			if( 'undefined' === typeof Isotope ){
				console.log(" Isotope has not defined yet! ");
				return;
			}

			jQuery('.bc-lookbooks.lookbooks.margin-row').isotope({
			  itemSelector: '.look-item',
			  layoutMode: 'fitRows'
			});
		}
		if( jQuery('.bc-lookbooks.lookbooks.look-slider').length > 0 ){
		  
			if( 'undefined' === typeof Swiper ){
				console.log(" Swiper has not defined yet! ");
				return;
			}
          
          	$('body').addClass('carousel-lookbook');

            var swiper_look = new Swiper('.lookbooks-wrapper.look-slider', {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : true
                },
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev', 
                pagination: '.swiper-pagination',
                paginationType: 'progress',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 30
            });
		}      
	}
	
	,fixTitle : function(){ // fix title a in filter
		jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
		jQuery(".rt a").removeAttr("title");
        jQuery(".size-all").after(jQuery(".size-xxxl")).after(jQuery(".size-xxl")).after(jQuery(".size-xl")).after(jQuery(".size-l")).after(jQuery(".size-m")).after(jQuery(".size-s")).after(jQuery(".size-xs")).after(jQuery(".size-xxs")).after(jQuery(".size-xxxs"));
	}

	
	,swatch : function(){
        jQuery('.swatch :radio').change(function() {
          	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          	var optionValue = jQuery(this).val();
          	jQuery(this)
          	.closest('form')
          	.find('.single-option-selector')
          	.eq(optionIndex)
          	.val(optionValue)
          	.trigger('change');
        });
  	}
  
  	,switchImgProduct: function() {
    	$('.product-swatch-images .swatch-element > input').on('change', function(e){
    		
          	e.stopPropagation();
          	var imgUrl = $(this).data("swatch-image"),
                parent = $(this).parents('.product-wrapper'),
                imgElem = parent.find('.product-image img.featured-image');
          	imgElem.parents('.product-image').addClass('img-loading');
          	imgElem.attr('src', imgUrl)
          	var fakeImg = new Image();
          	fakeImg.src = imgUrl;
            fakeImg.onload = function(event){
                imgElem.parents('.product-image').removeClass('img-loading');
            };
            fakeImg.onerror = function() {
                //Code for error loading
            };
        });
    }
      
   //  ,slickProductPage: function(){

   //  	jQuery('.slider-for-03').on('init', function(){
   //      	let _url = $('.slick-current').find('img').attr('data-zoom');
			// $('.slick-current .slick-zoom')
		 //      .zoom({
		 //        url: _url
		 //    	});
   //      })

   //      jQuery('.slider-for-03').length && jQuery('.slider-for-03').slick({
   //        slidesToShow: 1
   //        ,slidesToScroll: 1
   //        ,arrows: true
   //        ,fade: true
   //	     ,dots: true
   //        ,asNavFor: '.slider-thumbs-03'
   //        ,nextArrow: $('.slick-btn-03 .btn-next')
   //        ,prevArrow: $('.slick-btn-03 .btn-prev')
   //      });

   //      jQuery('.slider-for-03').on('afterChange', function(){
   //      	$('.slick-zoom').trigger('zoom.destroy');
   //      	let _url = $('.slick-current').find('img').attr('data-zoom');
			// $('.slick-current .slick-zoom')
		 //      .zoom({
		 //        url: _url
		 //    	});
   //      })

   //      jQuery('.slider-thumbs-03').length && jQuery('.slider-thumbs-03').slick({
   //        infinite: false
   //        ,slidesToShow: 4
   //        ,slidesToScroll: 1
   //        ,asNavFor: '.slider-for-03'
   //        ,dots: true
   //        ,arrows: false
   //        ,focusOnSelect: true
   //        ,draggable: true
   //      });  
   //  }
           
	,scareName : function(){
		var _name_height = 0;
		jQuery('.product-wrapper').find('h5.product-name a, h5.product-name').each(function(){ 
			$(this).removeAttr('style');
		})
		jQuery('.product-wrapper').find('h5.product-name a, h5.product-name').each(function( index,value ){
			_name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
			jQuery('.product-wrapper').find('h5.product-name').css('height',_name_height); 
			$('.sidemenu-holder .product-wrapper,.menu-mobile .product-wrapper').find('h5.product-name').removeAttr('style');
		}); 


    }           
  
    ,scareScreen : function(){
      	if( typeof _bc_config == "undefined" ){
          	return;
      	}
      	var _current = this;
      
      	if( _bc_config.enable_title_blance == "true" ){
          	this.scareName();
      	}      
      	
      	jQuery( document ).ajaxComplete(function( event,request, settings ) {
          if( _bc_config.enable_title_blance == "true" ){
              _current.scareName();
          }  
        });  
    }

    ,highlightedWords: function(str, highlight, el){
      	var searchWord = str.indexOf(highlight);
		if (searchWord > -1) {
		  var arrayStr = str.split(highlight);
		  var hlWords = "<span class=\"highlighted\">" + highlight + "</span>";
		  if (arrayStr.length == 2) {
		    var newTitle = "" + arrayStr[0] + hlWords + " " + arrayStr[1];
		  } else {
		    var newTitle = arrayStr[0] + " " + hlWords + " " + arrayStr[1];
		  }
		  el.html(newTitle);
		}
  }

  ,hLWords_sectionProductTabs: function(str, elm){
    var n = str.split(" ");
	if (n.length > 1) {
	  var highlight = n[n.length - 1];
	  var strArray = str.split(highlight);
	  highlight = "<span class=\"highlight\">" + highlight + "</span>";

	  if (strArray.length == 2) {
	    var newText = "" + strArray[0] + highlight;
	  } else {
	    var newText = strArray[0] + " " + highlight;
	  }
	  elm.html(newText);
	}
  }

  	,productSlider : function(){
	    var bxMode;
	    var elm = $('.bxslider');
	    var bxWrapperWidth = $('.more-view-image').width() + 15;

	    if (window.matchMedia("(min-width: 767px)").matches) {
	    	window.productThumbSlider = elm.bxSlider({
		        mode: 'vertical',
		        slideMargin: 20,
		        infiniteLoop:false,
		        minSlides:4,
		        maxSlides:4,
		        pager:false,
		        slideWidth: bxWrapperWidth,
		        prevText:'<i class="icon-up-open-1" title="Previous"></i>',
		        nextText:'<i class="icon-down-open-1" title="Next"></i>',
		    })  
	    }  
	}

	,refreshImage : function(){ // Update product image in detail page
		if(jQuery('.more-view-image').length){

			jQuery('.more-view-image .thumb-img').on('click', function() {

				var _$this = jQuery(this);

				if(!_$this.hasClass('active')){
					var parent = _$this.parents('.product-image-inner');
					// var src_original = _$this.attr('data-zoom-image');
					var src_display = _$this.attr('data-image');

					parent.find('.thumb-img').removeClass('active');
					_$this.addClass('active');

					// parent.find('.featured-image').find('img').attr('data-zoom-image', src_original);
                 	parent.find('.featured-image').find('img').attr('src', src_display);
				}

				return false;
			});
		}
	}

	,portfolio_filter: function(){
		if( jQuery('.portfolio-masonry').length > 0 ){

		    if( 'undefined' === typeof Isotope ){
		      console.log(" Isotope has not defined yet! ");
		      return;
		    }

		    let $grid = jQuery('.portfolio-masonry');

		    $grid.isotope({
		      itemSelector: '.portfolio-item',
		      layoutMode: 'packery'
		    });

		    $('.filter-button-group').on( 'click', 'button', function() {
		      	let filterValue = $( this ).attr('data-filter');
		      	$grid.isotope({ filter: filterValue });

		      	setTimeout(function(){
		      		$('.portfolio-item').each(function(){
			      		if($(this).css('display') == 'none'){
				    		$(this).find('.open-image').each(function(index, item){
				    			$(item).removeClass('fancybox');
				    		})
				    	} else {
				    		$(this).find('.open-image').each(function(index, item){
				    			$(item).addClass('fancybox');
				    		})
				    	}
			      	})
		      	},500);
		    });

		    $('.open-image').on('click',function(){
		    	jQuery('.fancybox').fancybox({
					closeBtn  : true,
					helpers : {
						buttons : {}
					}
				});
		    });
		}
	}
      
      	,model_filter: function(){
		if( jQuery('.model-container').length > 0 ){

		    if( 'undefined' === typeof Isotope ){
		      console.log(" Isotope has not defined yet! ");
		      return;
		    }

		    let $grid = jQuery('.model-container');

		    $grid.isotope({
		      itemSelector: '.models',
		      layoutMode: 'packery'
		    });
		    $('.filter-button-group').on( 'click', 'button', function() {
		      	let filterValue = $( this ).attr('data-filter');
		      	$grid.isotope({ filter: filterValue });
		      	setTimeout(function(){
		      		$('.models').each(function(){
			      		if($(this).css('display') == 'none'){
				    		$(this).find('.open-image').each(function(index, item){
				    			$(item).removeClass('fancybox');
				    		})
				    	} else {
				    		$(this).find('.open-image').each(function(index, item){
				    			$(item).addClass('fancybox');
				    		})
				    	}
			      	})
		      	},500);
		    });

		    $('.open-image').on('click',function(){
		    	jQuery('.fancybox').fancybox({
					closeBtn  : true,
					helpers : {
						buttons : {}
					}
				});
		    });
		}
	}


    ,totalFilter_2: function(_selector_title_2){
    	$("#chosen-select-1").chosen().change(function(event, params){
			$('#collection-search-wrapper .selector-wrapper').addClass('pending')
			setTimeout(function(){
				$('#chosen-select-1 option').each(function(index, item){
					if(index != 0) {
						let optionVal = $(this).val();
						if(optionVal == params.selected) {
							let colUrl = $(this).data('collection-url');

							let dataTags = $(this).data('tags');
							let dataCountTags = $(this).data('count-tags');
							if(dataTags !== undefined && dataCountTags != undefined) {
								if (_selector_title_2 != ''){
									$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
								}
								else {
									$('#chosen-select-2').empty()	
								}

								$("#chosen-select-2").trigger("chosen:updated");

								let dataTagsArray = [], dataCountTagsArray = [];
								if(dataTags.charAt( dataTags.length-1 ) == ",") {
								  dataTags = dataTags.slice(0, -1);
								  dataTagsArray = dataTags.split(',');
								} else {
									dataTagsArray = dataTags.split(',');
								} 

								if(dataCountTags.charAt( dataCountTags.length-1 ) == ",") {
								  dataCountTags = dataCountTags.slice(0, -1);
								  dataCountTagsArray = dataCountTags.split(',');
								} else {
									dataCountTagsArray = dataCountTags.split(',');
								} 

								dataTagsArray.forEach( function(tag, i) {
									dataCountTagsArray.forEach(function (count, j){
										if (i == j) {
											var optionElm = "<option value=\"" + tag + "\" data-collection-url=\"" + colUrl + "/" + tag + "\">" + tag + " (" + count + ")</option>";
											$('#chosen-select-2').append(optionElm);
											document.getElementById('chosen-select-2').disabled = false;
											$("#chosen-select-2").trigger("chosen:updated");
										}
									})

									$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
								})
							}
							else {
								if (_selector_title_2 != ''){
									$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
								}
								else {
									$('#chosen-select-2').empty()	
								}
								document.getElementById('chosen-select-2').disabled = true;
								$("#chosen-select-2").trigger("chosen:updated");

								$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
							};

							$('#search-collection').attr('href', colUrl);
							document.getElementById('search-collection').disabled = false;
							$('#reset-filter').show()
						}
					}
					else {
						if (_selector_title_2 != ''){
							$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
						}
						else {
							$('#chosen-select-2').empty()	
						}
						document.getElementById('chosen-select-2').disabled = true;
						$("#chosen-select-2").trigger("chosen:updated");

						$('#collection-search-wrapper .selector-wrapper').removeClass('pending')

						$('#search-collection').attr('href', 'javascript:;');
						$('#reset-filter').hide()
					}	
				})
			},1000)	
		});

		$("#chosen-select-2").chosen().change(function(event, params){
			$('#collection-search-wrapper .selector-wrapper').addClass('pending')
			setTimeout(function(){
				$('#chosen-select-2 option').each(function(index, item){
					if(index != 0) {
						let optionVal = $(this).val();
						if(optionVal == params.selected) {
							let colUrl = $(this).data('collection-url');
							$('#search-collection').attr('href', colUrl)
							$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
						}
					} 
					else {
						var defaultUrl = $('#search-collection').attr('href');
						var searchColUrlArray = defaultUrl.split('/');
						var searchColUrl = '/collection/' + searchColUrlArray[2];
						$('#search-collection').attr('href', searchColUrl);
						$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
					}	
				})
			},1000)
		});

		$('#reset-filter').on('click', function(){
			$('#collection-search-wrapper .selector-wrapper').addClass('pending')
			setTimeout(function(){
				$("#chosen-select-1").val("");
				$("#chosen-select-1").trigger("chosen:updated");

				if (_selector_title_2 != '') {
					$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
				}
				else {
					$('#chosen-select-2').empty()	
				}
				document.getElementById('chosen-select-2').disabled = true;
				$("#chosen-select-2").trigger("chosen:updated");

				$('#search-collection').attr('href', 'javascript:;')
				$('#reset-filter').hide()

				$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
			},1000)
		})
    }

    ,chosenSelect_1: function(_selector_title_2, _selector_title_3){
    	$("#chosen-select-1").chosen().change(function(event, params){
			$('#collection-search-wrapper .selector-wrapper').addClass('pending');
			setTimeout(function(){
				$('#chosen-select-1 option').each(function(index, item){
					if (index != 0) {
						let optionVal = $(this).val();

						if(optionVal == params.selected) {
							let colUrl = $(this).data('collection-url');

							let dataTags = $(this).data('tags');
							let dataTags_2 = $(this).data('tags-2');
							let dataCountTags = $(this).data('count-tags');

							if(dataTags != undefined && dataTags != '') {
								if (_selector_title_2 != '') {
									$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
								}
								else {
									$('#chosen-select-2').empty();	
								}
								$("#chosen-select-2").trigger("chosen:updated");

								if (_selector_title_3 != '') {
									$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
								} else {
									$('#chosen-select-3').empty();	
								}
								$("#chosen-select-3").trigger("chosen:updated");

								let dataTagsArray = [], dataCountTagsArray = [];
								if(dataTags.charAt( dataTags.length-1 ) == ",") {
								  dataTags = dataTags.slice(0, -1);
								  dataTagsArray = dataTags.split(',');
								} else {
									dataTagsArray = dataTags.split(',');
								} 

								if(dataCountTags.charAt( dataCountTags.length-1 ) == ",") {
								  dataCountTags = dataCountTags.slice(0, -1);
								  dataCountTagsArray = dataCountTags.split(',');
								} else {
									dataCountTagsArray = dataCountTags.split(',');
								} 

								dataTagsArray.forEach( function(tag, i) {
									dataCountTagsArray.forEach(function(count, j) {
										if (i == j) {
											var optionElm = "<option value=\"" + tag + "\" data-collection-url=\"" + colUrl + "/" + tag + "\" data-tags=\"" + dataTags_2 + "\">" + tag + " (" + count + ")</option>";

											$('#chosen-select-2').append(optionElm);
											document.getElementById('chosen-select-2').disabled = false;
											$("#chosen-select-2").trigger("chosen:updated");
										}
									})

									$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
								})
							}
							else {
								if (_selector_title_2 != '') {
									$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
								} else {
									$('#chosen-select-2').empty()	
								}
								document.getElementById('chosen-select-2').disabled = true;
								$("#chosen-select-2").trigger("chosen:updated");

								if (_selector_title_3 != '') {
									$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
								} else {
									$('#chosen-select-3').empty()	
								}
								document.getElementById('chosen-select-3').disabled = true;
								$("#chosen-select-3").trigger("chosen:updated");

								$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
							}

							$('#search-collection').attr('href', colUrl);
						}
					}
					else {
						if (_selector_title_2 != '') {
							$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
						} else {
							$('#chosen-select-2').empty()	
						}
						document.getElementById('chosen-select-2').disabled = true;
						$("#chosen-select-2").trigger("chosen:updated");

						if (_selector_title_3 != '') {
							$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
						} else {
							$('#chosen-select-3').empty()	
						}
						document.getElementById('chosen-select-3').disabled = true;
						$("#chosen-select-3").trigger("chosen:updated");

						$('#search-collection').attr('href', 'javascript:;');

						$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
					}
				})

				$('#reset-filter').show()
			},1000)	
		});
    }

    ,chosenSelect_2: function(_selector_title_3){
    	$("#chosen-select-2").chosen().change(function(event, params){
			$('#chosen-select-2 option').each(function(index, item){
				let defaultUrl = $('#search-collection').attr('href');
				
				if(index != 0) {
					let optionVal = $(this).val();
					if(optionVal == params.selected) {
						$('#collection-search-wrapper .selector-wrapper').addClass('pending')

						let colUrl = $(this).data('collection-url');
						$('#search-collection').attr('href', colUrl)
							
						let dataTags = $(this).data('tags');
						if(dataTags != undefined) {
							let dataTagsArray = dataTags.split(';');
							if (dataTagsArray[0] != 'undefined' ) {
								$.ajax({
									url: colUrl,

									success: function ( response ) {
										if (_selector_title_3 != '') {
											$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
										} else {
											$('#chosen-select-3').empty()	
										}
										$("#chosen-select-3").trigger("chosen:updated");

										let _document = $(response);
										let tagArray = [],
											filterTagArr = [];
										_document.find('.cata-product .quick_shop').each(function(){
											let dataJson = $(this).find('span.json').html();
											let productJson = JSON.parse(dataJson);
											let productTagArray = productJson.tags;

											tagArray.push(productTagArray)
										})

										let stringify_tagArray = tagArray.toString();
										tagArray = stringify_tagArray.split(',')
										
										dataTagsArray.forEach(function(dataTag) {
	                                      	let countObj = {
	                                          item: dataTag,
	                                          count: 0
	                                        }
	                                        filterTagArr.push(countObj)
											tagArray.forEach(function(tag){
												if(dataTag == tag) {
	                                             	countObj.count++; 
												}
											})
										})

										filterTagArr.sort(function(a,b){
											if(a.item < b.item) return -1;
										    if(a.item > b.item) return 1;
										    return 0;
										});

										filterTagArr.forEach(function(tag){
											if (tag.count > 0) {
												let optionElm;
												if((tag.item).indexOf(' ')){
													let item = (tag.item).replace(' ', '-')
													optionElm = "<option value=\"" + tag.item + "\" data-collection-url=\"" + colUrl + "+" + item + "\">" + tag.item + " (" + tag.count + ")</option>";
												} else {
													optionElm = "<option value=\"" + tag.item + "\" data-collection-url=\"" + colUrl + "+" + tag.item + "\">" + tag.item + " (" + tag.count + ")</option>";
												}
												$('#chosen-select-3').append(optionElm);

												document.getElementById('chosen-select-3').disabled = false;

												$("#chosen-select-3").trigger("chosen:updated");

												$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
											} else {
												$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
											}
										})
									},
									error: function() {
										console.log('error AJAX filter lv 2')
									}
								})
							} 
							else {
								setTimeout(function(){
									console.log('dataTagsArray')
									if (_selector_title_3 != '') {
										$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
									} else {
										$('#chosen-select-3').empty()	
									}
									document.getElementById('chosen-select-3').disabled = true;
									$("#chosen-select-3").trigger("chosen:updated");

									$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
								},1000)
							}
						}	
						else {
							setTimeout(function(){
								console.log('dataTags')
								if (_selector_title_3 != '') {
									$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
								} else {
									$('#chosen-select-3').empty()	
								}
								document.getElementById('chosen-select-3').disabled = true;
								$("#chosen-select-3").trigger("chosen:updated");

								$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
							},1000)
						}
					}
				}
				else {
					if (_selector_title_3 != '') {
						$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
					} else {
						$('#chosen-select-3').empty()	
					}
					document.getElementById('chosen-select-3').disabled = true;
					$("#chosen-select-3").trigger("chosen:updated");

					var searchColUrlArray = defaultUrl.split('/');
					var searchColUrl = '/collection/' + searchColUrlArray[2];
					$('#search-collection').attr('href', searchColUrl);	
				}
				
			})
		});
    }

    ,resetFilter: function(_selector_title_2, _selector_title_3){
    	$('#reset-filter').on('click', function(){
			$('#collection-search-wrapper .selector-wrapper').addClass('pending')
			setTimeout(function(){
				$("#chosen-select-1").val("")
				$("#chosen-select-1").trigger("chosen:updated");

				if (_selector_title_2 != '') {
					$('#chosen-select-2').html('<option value="' + _selector_title_2 + '">' + _selector_title_2 + '</option>');
				} else {
					$('#chosen-select-2').empty()	
				}
				document.getElementById('chosen-select-2').disabled = true;
				$("#chosen-select-2").trigger("chosen:updated");

				if (_selector_title_3 != '') {
					$('#chosen-select-3').html('<option value="' + _selector_title_3 + '">' + _selector_title_3 + '</option>');
				} else {
					$('#chosen-select-3').empty()	
				}
				document.getElementById('chosen-select-3').disabled = true;
				$("#chosen-select-3").trigger("chosen:updated");

				$('#search-collection').attr('href', 'javascript:;')
				$('#reset-filter').hide()

				$('#collection-search-wrapper .selector-wrapper').removeClass('pending')
			},1000)
		})
    }

    ,swatch_product_image: function(){
	    var elm = $('.product-swatch-images .swatch');

	    setTimeout(function(){
	        elm.bxSlider({
		        mode: 'vertical',
		        slideMargin: 3,
		        infiniteLoop:false,
		        minSlides:4,
		        maxSlides:4,
		        pager:false,
		        slideWidth: 50,
		        controls: false,
		    }) 	
	    },500)
 
    }
		,fixlayoutCustomSectionImage: function(){
			let element= $('.custom-item-inner-image');
			let number = $(element).find('.custom-block-image').length;
			if (number == 2 ){
				$(element).parents('.custom-item').addClass('two-block-inside');
			}

		}
    ,megamenuWithTabs : function(){
      jQuery(".tab-title .title-item").hover(function(e){
        $('.title-item').removeClass('active');
        $('.tab-content-inner').removeClass('active');

        let titleclass = $(this).attr('data-id');
        let elementclass = "." + titleclass;
        
        $(elementclass).addClass('active');
      });
      
      jQuery(".mega-menu").mouseleave(function(){
        $('.title-item').removeClass('active');$('.title-item-1').addClass('active');
        $('.tab-content-inner').removeClass('active');$('.mm-tabs-1').addClass('active')
      });
    }
    
    ,menuLeftColumnHomepage: function(){
    	let _htmlVerticalNav = $('.vertical-menu').find('.vertical-navbar').html();
      	$('.left-column-container .sb-vertical-menu .vertical-navbar').html(_htmlVerticalNav);

      	$('.left-column-container .sb-vertical-menu .vertical-navbar .main-nav>li').click(function(event){
        	let e = this;
        	if( event.target !== e ) {
			    return;
			}
        	$('.left-column-container .sb-vertical-menu .vertical-navbar .main-nav>li').each(function(index,item){
          
	          	if(e != item) {
	            	$(item).removeClass('menu-open')
	          	}
        	})
 
	        e = $(this);
			if(e.hasClass('dropdown')) {
				if(e.hasClass('menu-open')) {
					e.removeClass('menu-open'); 
				}
				else {
					e.addClass('menu-open');
				}
			}
	       
      	})

      	$('body').click(function(element) {
        	if ($(element.target).closest('.vertical-navbar').length == 0) {
          		$('.left-column-container .sb-vertical-menu .vertical-navbar .main-nav>li.dropdown').removeClass('menu-open');
        	}
      	}); 

      	setTimeout(function(){
            if(AT_Main.getWidthBrowser() < 992) {
              jQuery(".left-column-container .sb-vertical-menu .menu-product-carousel").length && jQuery(".left-column-container .sb-vertical-menu .menu-product-carousel").owlCarousel({
                  loop: !1,
                  nav: !0,
                  dots: !1,
                  items: 1,
                  navText: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
              })
            } 
            else {
              jQuery(".left-column-container .sb-vertical-menu .menu-product-carousel").length && jQuery(".left-column-container .sb-vertical-menu .menu-product-carousel").owlCarousel({
                  loop: !1,
                  nav: !0,
                  dots: !1,
                  items: 1,
                  navText: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
              })
            }  
        },1000) 
    }
      ,getSelectedTag: function(){
      $('#easysearch-search').on('click', function(e){
        e.preventDefault();
      	let easySearchHref = $('#easysearch-search').attr('href');
        easySearchHref = easySearchHref.split('/');
        let selectedTag = easySearchHref[3];
        
        if(Cookies.set('easySearchTag')){
        	Cookies.remove('easySearchTag', { path: '/' });
          	Cookies.set('easySearchTag', selectedTag, { path: '/' }, { expires : 30 }, { secure: true });
        } else {
        	Cookies.set('easySearchTag', selectedTag, { path: '/' }, { expires : 30 }, { secure: true });
        }

        setTimeout(function () {
           window.location.href = $('#easysearch-search').attr('href'); 
        }, 1000);
      })
    } 
 
    ,hideModelSearch: function() {
      if(Cookies.get('easySearchTag')){
 jQuery('.search-model__refineby, .page-hero-model-holder__selected, #mobile-dropdown_selected').css('display', 'block');
 jQuery('.search-model__select, .page-hero-model-holder, .home-slideshow-wrapper .swiper-pagination, #mobile-dropdown_select, .page-hero-model-holder__brand-page').css('display', 'none');
      }
            else {
    jQuery('.search-model__select, .page-hero-model-holder, #mobile-dropdown_select, .page-hero-model-holder__brand-page').css('display', 'block');
    jQuery('.search-model__refineby, .page-hero-model-holder__selected, #mobile-dropdown_selected').css('display', 'none');

    }
    }
    ,myModelName: function() {
      if(Cookies.get('easySearchTag')){
        let selectedTag = Cookies.get('easySearchTag');
        let modelTitle = toUpper(selectedTag);	
        let menuTitle = 'My ŠKODA (1)';
        $('.main-header__holder ul.toolbar__list li.toolbar__item span.toolbar__item-mycarlabel, button.carselector__mobile-cta').text(menuTitle);
      	$('.my-model-content__selected-name span, .page-hero-model-holder__selected-name span, .my-model-content-mobile__selected-name').text(modelTitle);	
        $('.top-bar .top-bar-right ul li.my-model, .mobile-header-dropdown__selected-icon').show();
        $('#clear-model_header, .my-model-content__selected-name').show();
      }
            else {
      	let text = 'YOU CURRENTLY HAVE NO SAVED VEHICLES';
        let selectmodel = 'Select your ŠKODA';
            $(".top-bar .top-bar-right ul li.my-model h5").text(text);
            $("button.carselector__mobile-cta").text(selectmodel);
            $('#select-model_header, .my-model-content__notselected, .mobile-header-dropdown__car-icon').show(); 
    }
      
      function toUpper(str) {
        return str
            .toLowerCase()
            .split('-')
            .map(function(word) {
                return word[0].toUpperCase() + word.substr(1);
            })
            .join(' ');
      }
    }
              
    ,clearEasySearch: function() {
      $('#clear-model_header, #clear-model, #clear-model_mobile-dropdown').on('click', function(){        
        if($('body').hasClass('templateCollection')){
        	let url = window.location.href;
			let selectedTag = Cookies.get('easySearchTag');
          
          	if(url.indexOf(selectedTag) > -1) {
              let newUrl = url.replace(selectedTag, "");
              Cookies.remove('easySearchTag', { path: '/' });
              setTimeout(function(){
              	window.location.href = newUrl;
              },1000)
            } else {
              	Cookies.remove('easySearchTag', { path: '/' });
                setTimeout(function(){
                  location.reload();
                },1000)
            }
        } else {
          	Cookies.remove('easySearchTag', { path: '/' });
        	setTimeout(function(){
              location.reload();
            },1000)
        }
        
      })
    }
         ,selectedTagNavigation: function(){
		if(Cookies.get('easySearchTag')){
          let selectedTag = Cookies.get('easySearchTag');
          let checkName = [{name : "škoda accessories"}, {name:"škoda parts"}];

          $('.main-header__horizontal-menu ul.menu-list li, .menu-mobile ul.main-nav li').each(function(){
            if($(this).hasClass('dropdown')){
              let menuItemTitle = $(this).children("a:first-child").find("span").text();
              for (let i =0; i<= checkName.length - 1; i++){
                if(menuItemTitle.toLowerCase() === checkName[i].name){
                  let parentItem = $(this).children("a:first-child");
                  let parentHref = parentItem.attr("href");
//                   if(getHref != undefined && getHref.indexOf('collections') > -1 && href.indexOf('?') == -1) {
//                     let newGetHref = getHref + "/" + selectedTag;
//                     $(this).children("a:first-child").attr("href", newGetHref);
//                   }
                  modifyHref(parentHref, parentItem, selectedTag)
                  
                  
                  $(this).children(".dropdown-menu").find("a").each(function(index, item){
                    let _item = $(item);
                    let href = $(item).attr("href");
//                     if(href != undefined && href.indexOf('collections') > -1 && href.indexOf('?') == -1) {
//                       let newHref = href + "/" + selectedTag;
//                       $(item).attr("href", newHref);
//                     }
                    modifyHref(href, _item, selectedTag)
                  })
                } 
              }

            }
          })
        }
      
        function modifyHref(href, item, selectedTag) {
          if(href != undefined && href.indexOf('collections') > -1 && href.indexOf('?') == -1) {
            let newHref = href + "/" + selectedTag;
            item.attr("href", newHref);
          }
        }
    } 
      ,overlay: function(){
        var megaMenu = $('.navbar ul.menu-list li.mega-menu')
    megaMenu.on('mouseover', function() {
                $(this).closest('.boxed-wrapper').children('.overlay').css({
                    opacity: '1',
                    display: 'block',
                });
            });
           megaMenu.on('mouseleave', function() {
                $(this).closest('.boxed-wrapper').children('.overlay').css({
                    opacity: '0',
                    display: 'none',
                });
            });
         }
      
      	,toggleFooter : function(){
          if(AT_Main.getWidthBrowser() < 992) {
        jQuery(document).on('click', '.footer-block h6>span, .footer-block h6', function(e) {
          jQuery(this).closest('.footer-block').find('h6').toggleClass('opened');
          jQuery(this).closest('.footer-block').find('.f-list').slideToggle();
        });
	}
        }

             ,slickProductPage: function(){

        jQuery('.slider-for-03').length && jQuery('.slider-for-03').slick({
          slidesToShow: 1
          ,slidesToScroll: 1
          ,arrows: true
          ,fade: true
          ,dots: true
          ,asNavFor: '.slider-thumbs-03'
          ,nextArrow: $('.slick-btn-03 .btn-next')
          ,prevArrow: $('.slick-btn-03 .btn-prev')
        });

        jQuery('.slider-thumbs-03').length && jQuery('.slider-thumbs-03').slick({
          infinite: false
          ,slidesToShow: 4
          ,slidesToScroll: 1
          ,asNavFor: '.slider-for-03'
          ,dots: false
          ,arrows: false
          ,focusOnSelect: true
        });  
    }    
        ,messageSlider: function(){
        jQuery('.service-item-list').slick({
    dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 992,
      settings: {
       slidesToShow: 3,
      slidesToScroll: 3
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
       cssEase: 'linear'
      }
    }
  ]
});
        }
  
        ,carSlider: function(){
        jQuery('.car-list__container').slick({
    dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
    {
      breakpoint: 992,
      settings: {
       slidesToShow: 5,
      slidesToScroll: 5
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});
        }
   ,sliderHero: function(){
        jQuery('.home-hero-banner').slick({
    dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 6000,
   fade: true,
       cssEase: 'linear'
        
        });
   }
        ,howto: function(){
        jQuery('.how-to-buy__container').slick({
    dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 9999,
     settings: "unslick"
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
       cssEase: 'linear',
        dots: true
      }
    }
  ]
});
        }
	,init : function(){
      
      	if( typeof _bc_config == 'undefined' ){
           	 console.log( " _bc_config is undefined " );
           	 return ;
				}
			
        this.stickMenu();
		this.toTopButton();
      	this.toggleVerticalMenu();
      	this.toggleCartSidebar();
      	this.toggleFilterMobileSb();
      	this.toggleFilterSidebar();
     	this.toggleReg();
      	this.parallaxIt();
      	this.effectNavigation();
        this.fixButton();
		this.menuOnMobile();
		this.handleMenuMultiLine();
		this.fixTitle();
        this.swatch();
      	this.switchImgProduct();
      	this.refreshImage();
				// this.slickProductPage();
		this.swatch_product_image();	
		this.megamenuWithTabs();	
		this.fixlayoutCustomSectionImage();
		this.toggleDropdownVerticalMenu();
		this.width_Nopadding();
         this.getSelectedTag();
      this.myModelName();
      this.clearEasySearch();
       this.selectedTagNavigation();
      this.overlay();
      this.toggleFooter();
      this.slickProductPage();
      this.hideModelSearch();
      this.messageSlider();
      this.howto();		
       this.toggleSortMobileSb();
      this. sliderHero();
      this. carSlider();
      this. toggleCarSelectorMobile();
     
	}
}


/* Handle when window resize */
jQuery(window).resize(function() {
    
    /* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }

	/*Reset Page when fixNoScroll had called before*/
	AT_Main.fixReturnScroll();
	AT_Main.width_Nopadding();
	if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
		jQuery("#page-body").trigger('click');
     	
});
      
jQuery(document).ready(function($) {
	
	
	AT_Main.init();
	if($('body').hasClass('templateCart') && $('body').find('.terms-conditions')){
		AT_Main.termsAndConditions();
	}
  
  	/* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
		}

		
});
$(window).on('load', function(){
	// setTimeout(function(){
		var body= $('#body-content'),
		bodyTop= body.offset().top;
		$(window).scroll(function() {
			AT_Main.smoothBody(bodyTop);	
		});
		
	// },500)
 
	$('body').addClass('layout_loaded')
		//AT_Main.slickProductPage();
	
		
})
